/* global VXConfig */
import Translations from '../../utils/Translations.js';
import { matchPath } from 'react-router';
import Flux from '../../flux/Flux.js';
import { TYPES } from '../Loader/Loader.js';
import { VXPay } from '../../utils/VXPay.js';
import VXButtonPrivateVideoCall from '../SimpleElements/VXButton/Presets/VXButtonPrivateVideoCall.js';
import STYLES from '../SimpleElements/VXButton/EnumVXButton.js';

const isActivePath = (path, pathname) => Boolean(matchPath({ path }, pathname));

const ROUTES = {
	de: {
		TOP100: 'de/top-cams/',
		FAVORITES: 'die-beliebtesten-favoriten/',
		CHATS: 'die-besten-chats/',
		VIDEOCALL: 'videocall/',
	},
	en: {
		TOP100: ':language/top-cams/',
		FAVORITES: 'most-popular-favorites/',
		CHATS: 'top-rated-chats/',
		VIDEOCALL: 'videocall/',
	},
	es: {
		TOP100: ':language/top-cams/',
		FAVORITES: 'favoritos-mas-populares/',
		CHATS: 'chats-mejor-calificados/',
		VIDEOCALL: 'videocall/',
	},
};

const baseRoute = ROUTES[VXConfig.language].TOP100;

const NAVIGATION_ITEMS = {
	TOP100: 'top100',
	FAVORITES: 'favorites',
	CHATS: 'chats',
	VIDEOCALL: 'videocall',
};

const isActivePathFavorites = (pathname) => isActivePath(baseRoute + ROUTES[VXConfig.language].FAVORITES, pathname);
const isActivePathChats = (pathname) => isActivePath(baseRoute + ROUTES[VXConfig.language].CHATS, pathname);
const isActivePathVideoCall = (pathname) => isActivePath(baseRoute + ROUTES[VXConfig.language].VIDEOCALL, pathname);

const t = (key, ...args) => Translations.get(`top_cams.${key}`, args);

const onVideocallClick = (actorId) => {
	if (Flux.Guest.isLoggedIn()) {
		Flux.Special.showLoader(TYPES.DOT);
		Flux.NewMessenger.startChat(Flux.Constants.VXMessenger.ChatTypes.VIDEOCALL, actorId);
	} else {
		VXPay.openSignupOrLogin();
	}
};

const getButtonForCategory = (category, modelData) => {
	let button;

	switch (category) {
		case Flux.Constants.TopCams.Categories.VIDEOCALL:
			if (modelData.onlineVideocall && modelData?.videocallPrice?.singleC2CChat?.value && !Flux.Guest.isVoicecallActive()) {
				button = (
					<VXButtonPrivateVideoCall
						onClick={() => onVideocallClick(modelData.id)}
						price={modelData.videocallPrice.singleC2CChat.value}
						size={STYLES.SIZE.SMALL}
					/>
				);
			}
			break;
		case Flux.Constants.TopCams.Categories.FAVORITES:
		case Flux.Constants.TopCams.Categories.BEST_CHATS:
		case Flux.Constants.TopCams.Categories.TOP_100:
		default:
			button = null;
	}
	return button;
};

const getTranslationForCategory = (category, isMobile) => {
	const translations = {
		[Flux.Constants.TopCams.Categories.TOP_100]: {
			header: isMobile ? 'top_cams.headline-top100-mobile' : 'top_cams.headline-top100',
			description: 'CategoryOverviewTop100Text',
			infoText: '',
		},
		[Flux.Constants.TopCams.Categories.BEST_CHATS]: {
			header: isMobile ? 'top_cams.headline-chat-mobile' : 'top_cams.headline-chat',
			description: 'CategoryOverviewTopChatsText',
			infoText: 'top_cams.headline-sub-chat',
		},
		[Flux.Constants.TopCams.Categories.FAVORITES]: {
			header: isMobile ? 'top_cams.headline-favorites-mobile' : 'top_cams.headline-favorites',
			description: 'CategoryOverviewTopFavoritesText',
			infoText: 'top_cams.headline-sub-favorites',
		},
		[Flux.Constants.TopCams.Categories.VIDEOCALL]: {
			header: 'top_cams.headline-videocall',
			description: isMobile ? 'top_cams.headline-sub-videocall-mobile' : 'top_cams.headline-sub-videocall',
			infoText: 'Online',
		},
		[Flux.Constants.TopCams.Categories.LENI_GIRLS]: {
			header: 'top_cams.headline-leni-girls',
		},
		[Flux.Constants.TopCams.Categories.LEXY_GIRLS]: {
			header: 'top_cams.headline-lexy-girls',
		},
		[Flux.Constants.TopCams.Categories.LUCY_GIRLS]: {
			header: 'top_cams.headline-lucy-girls',
		},
		[Flux.Constants.TopCams.Categories.LANA_GIRLS]: {
			header: 'top_cams.headline-lana-girls',
		},
		[Flux.Constants.TopCams.Categories.LIA_GIRLS]: {
			header: 'top_cams.headline-lia-girls',
		},
	};

	return translations[category] || { header: '', description: '' };
};

const getBreadcrumbType = (category) => {
	switch (category) {
		case NAVIGATION_ITEMS.FAVORITES:
			return Flux.Constants.Breadcrumb.TOP_CAMS_TOP_FAVORITES;
		case NAVIGATION_ITEMS.CHATS:
			return Flux.Constants.Breadcrumb.TOP_CAMS_BEST_CHATS;
		case NAVIGATION_ITEMS.VIDEOCALL:
			return Flux.Constants.Breadcrumb.TOP_CAMS_TOP_VIDEOCALL;
		case NAVIGATION_ITEMS.TOP100:
		default:
			return Flux.Constants.Breadcrumb.TOP_CAMS_TOP_100;
	}
};

export {
	ROUTES,
	NAVIGATION_ITEMS,
	
	t,
	isActivePathFavorites,
	isActivePathChats,
	isActivePathVideoCall,
	
	getButtonForCategory,
	getTranslationForCategory,
	getBreadcrumbType,
};
